<div class="page-content">
    <div class="page-header">
        <h1>{{ title }}</h1>
        <div class="page-description">{{ subTitle }}</div>
    </div>
    <div class="page-body">
        <div class="container-fluid cards-container">
            @let kpi = kpis()[0];
            <div class="row g-3">
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.mvDeparturesRateAbove5Percent.title"
                        [body]="{
                            value: kpi.mvDeparturesRateAbove5Percent,
                            precision: texts.mvDeparturesRateAbove5Percent.precision,
                            suffix: texts.mvDeparturesRateAbove5Percent.suffix,
                        }"
                        [badge]="{
                            value: kpi.mvDeparturesRateAbove5PercentEvolution,
                            suffix: texts.mvDeparturesRateAbove5Percent.badgeSuffix,
                            precision: texts.mvDeparturesRateAbove5Percent.badgePrecision,
                            style:
                                kpi.mvDeparturesRateAbove5PercentEvolution! < 0
                                    ? 'success'
                                    : 'danger',
                        }"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'mvDeparturesRateAbove5Percent')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.lvCmaRate.title"
                        [body]="{
                            value: kpi.lvCmaRate,
                            precision: texts.lvCmaRate.precision,
                            suffix: texts.lvCmaRate.suffix,
                        }"
                        [badge]="{
                            value: kpi.lvCmaRateEvolution,
                            suffix: texts.lvCmaRate.badgeSuffix,
                            precision: texts.lvCmaRate.badgePrecision,
                            style: kpi.lvCmaRateEvolution! < 0 ? 'success' : 'danger',
                        }"
                        [descriptionTitle]="texts.lvCmaRate.descriptionTitle"
                        [descriptionContent]="texts.lvCmaRate.descriptionContent"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'lvCmaRate')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.numberOfLvCma.title"
                        [body]="{
                            value: kpi.numberOfLvCma,
                            precision: texts.numberOfLvCma.precision,
                        }"
                        [badge]="{
                            value: kpi.numberOfLvCmaEvolution,
                            suffix: texts.numberOfLvCma.badgeSuffix,
                            precision: texts.numberOfLvCma.badgePrecision,
                            style: kpi.numberOfLvCmaEvolution! < 0 ? 'success' : 'danger',
                        }"
                        [descriptionTitle]="texts.numberOfLvCma.descriptionTitle"
                        [descriptionContent]="texts.numberOfLvCma.descriptionContent"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'numberOfLvCma')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.numberOfLvDma.title"
                        [body]="{
                            value: kpi.numberOfLvDma,
                            precision: texts.numberOfLvDma.precision,
                        }"
                        [badge]="{
                            value: kpi.numberOfLvDmaEvolution,
                            suffix: texts.numberOfLvDma.badgeSuffix,
                            precision: texts.numberOfLvDma.badgePrecision,
                            style: kpi.numberOfLvDmaEvolution! < 0 ? 'success' : 'danger',
                        }"
                        [descriptionTitle]="texts.numberOfLvDma.descriptionTitle"
                        [descriptionContent]="texts.numberOfLvDma.descriptionContent"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'numberOfLvDma')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
            </div>

            <chart-card
                id="evolutionMvDepartCtAbove5PercentChart"
                [title]="texts.evolutionMvDepartCtAbove5PercentChart.title"
                [error]="chartError"
                [isLoading]="!chartData()[0].organizationId"
                [series]="chartSeries"
                [dataLabels]="dataLabels"
                [stacked]="true"
                [xaxisCategories]="xaxisCategories"
                [yaxis]="yaxis"
                [precision]="texts.evolutionMvDepartCtAbove5PercentChart.precision"
                [customTooltip]="mvRateCustomTooltip"
                [xaxisTitle]="texts.evolutionMvDepartCtAbove5PercentChart.xaxisTitle"
                class="h-100">
            </chart-card>

            <chart-card
                id="evolutionNbrLvDepartPoorChart"
                [title]="texts.evolutionNbrLvDepartPoorChart.title"
                [error]="lvDepartChartError"
                [isLoading]="!lvDepartChartData()[0].organizationId"
                [series]="lvDepartChartSeries"
                [dataLabels]="lvDepartDataLabels"
                [stacked]="true"
                [xaxisCategories]="lvDepartXaxisCategories"
                [yaxis]="lvDepartYaxis"
                [precision]="texts.evolutionNbrLvDepartPoorChart.precision"
                [customTooltip]="lvDepartCustomTooltip"
                [xaxisTitle]="texts.evolutionNbrLvDepartPoorChart.xaxisTitle"
                [legend]="lvDepartLegend"
                class="h-100">
            </chart-card>

            <chart-card
                id="evolutionNbrRateCmaChart"
                [title]="texts.evolutionNbrRateCmaChart.title"
                [error]="rateCmaChartError"
                [isLoading]="!rateCmaChartData()[0].organizationId"
                [series]="rateCmaChartSeries"
                [dataLabels]="rateCmaDataLabels"
                [stacked]="true"
                [xaxisCategories]="rateCmaXaxisCategories"
                [yaxis]="rateCmaYaxis"
                [precision]="texts.evolutionNbrRateCmaChart.precision"
                [customTooltip]="rateCmaCustomTooltip"
                [xaxisTitle]="texts.evolutionNbrRateCmaChart.xaxisTitle"
                [legend]="rateCmaLegend"
                class="h-100">
            </chart-card>

            <chart-card
                id="voltageQualityComparison"
                [title]="texts.voltageQualityComparisonChart.title"
                [descriptionTitle]="texts.voltageQualityComparisonChart.descriptionTitle"
                [descriptionContent]="texts.voltageQualityComparisonChart.descriptionContent"
                [error]="voltageQualityComparisonChartError"
                [isLoading]="!voltageQualityComparisonChartDataSignal()[0].organizationId"
                [type]="'rangeBar'"
                [dataLabels]="voltageQualityComparisonDataLabels"
                [series]="voltageQualityComparisonChartSeries"
                [plotOptions]="voltageQualityComparisonPlotOptions"
                [customTooltip]="voltageQualityComparisonCustomTooltip"
                cardClass="h-100">
            </chart-card>

            <table-card
                [title]="texts.mvDeparturesTable.title"
                [dataSource]="mvDeparturesTableDataSource"
                [displayedColumns]="mvDeparturesDisplayedColumns"
                [error]="mvDeparturesTableError"
                [isLoading]="!mvDeparturesTableData()[0].organizationId"
                cardClass="h-100">
            </table-card>

            <table-card
                [title]="texts.substationCmaTable.title"
                [dataSource]="substationCmaTableDataSource"
                [displayedColumns]="subStationCmaDisplayedColumns"
                [error]="substationCmaTableError"
                [isLoading]="!substationCmaTableData()[0].organizationId"
                cardClass="h-100">
            </table-card>

            <div class="row">
                <div class="col-12">
                    <geo-map-card
                        [title]="texts.lvCmaRateMap.title"
                        [descriptionContent]="texts.lvCmaRateMap.descriptionContent"
                        [descriptionTitle]="texts.lvCmaRateMap.descriptionTitle"
                        [geometries]="geometries()"
                        [isLoading]="!geometries()[0].organizationId"
                        [error]="!!geometries()[0].error"
                        [getStyle]="getMapStyle"
                        [legendConfig]="legendConfig"
                        [mapId]="'lvCmaRateMap'"
                        [getTooltip]="getTooltip"></geo-map-card>
                </div>
            </div>
        </div>
    </div>
</div>
